var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpiceIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e7555f8d-db44-4858-90d7-07f91ef1df72",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 140.56 140.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M81.44,109,53.68,119a7.36,7.36,0,0,1-9.5-4.66L24.53,53.69A2.94,2.94,0,0,1,26.32,50L58.47,38.44a2.91,2.91,0,0,1,3.71,1.67l23.6,59.25A7.35,7.35,0,0,1,81.44,109Z",
    style: {
      fill: "#ecf6fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.18,40.11a2.91,2.91,0,0,0-3.71-1.67L42.4,44.23,67.56,114l13.88-5a7.35,7.35,0,0,0,4.34-9.65Z",
    style: {
      fill: "#d4e9fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.61,100.64a2.92,2.92,0,0,1-3.74-1.73L50.25,57.19A2.93,2.93,0,0,1,52,53.42h0a2.92,2.92,0,0,1,3.74,1.72L71.36,96.86a2.92,2.92,0,0,1-1.72,3.77Z",
    style: {
      fill: "#b2d9f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.45,105h0a2.93,2.93,0,0,1-3.73-1.81L39.08,61.14a2.93,2.93,0,1,1,5.54-1.92l14.6,42.09A2.93,2.93,0,0,1,57.45,105Z",
    style: {
      fill: "#d4e9fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.56,53.78l-2.52-7A10.42,10.42,0,0,1,28.3,33.47L46.38,27A10.42,10.42,0,0,1,59.7,33.21l2.52,7Z",
    style: {
      fill: "#295b97"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.38,27l-9,3.26,6,16.78L62.22,40.2l-2.52-7A10.42,10.42,0,0,0,46.38,27Z",
    style: {
      fill: "#163756"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.78,120.22l-29-5.46A7.37,7.37,0,0,1,62,105.92L75.82,43.67a2.92,2.92,0,0,1,3.4-2.24l33.58,6.32a2.94,2.94,0,0,1,2.36,3.33l-9.74,63a7.36,7.36,0,0,1-8.64,6.11Z",
    style: {
      fill: "#ffd577"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.16,51.08a2.94,2.94,0,0,0-2.36-3.33L96,44.59l-13.73,72.9,14.5,2.73a7.36,7.36,0,0,0,8.64-6.11Z",
    style: {
      fill: "#f6a860"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.83,107a2.92,2.92,0,0,1-2.34-3.38l7.72-43.88a2.93,2.93,0,0,1,3.39-2.38h0A2.92,2.92,0,0,1,102,60.75l-7.72,43.88A2.93,2.93,0,0,1,90.87,107Z",
    style: {
      fill: "#e9834d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.13,104.61h0a2.93,2.93,0,0,1-2.29-3.45l8.78-43.69a2.93,2.93,0,0,1,5.74,1.16l-8.78,43.68A2.92,2.92,0,0,1,78.13,104.61Z",
    style: {
      fill: "#f6a03d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8,43.76l1.38-7.3a10.41,10.41,0,0,1,12.15-8.3l18.89,3.56a10.41,10.41,0,0,1,8.3,12.15l-1.38,7.3Z",
    style: {
      fill: "#295b97"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.22,31.72l-9.45-1.78-3.3,17.53,19.67,3.7,1.38-7.3a10.41,10.41,0,0,0-8.3-12.15Z",
    style: {
      fill: "#163756"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.32,120.22l-29-5.46a7.37,7.37,0,0,1-5.82-8.84L75.36,43.67a2.92,2.92,0,0,1,3.4-2.24l33.58,6.32a2.94,2.94,0,0,1,2.36,3.33l-9.74,63a7.36,7.36,0,0,1-8.64,6.11Z",
    style: {
      fill: "#f7c201"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.7,51.08a2.94,2.94,0,0,0-2.36-3.33L95.55,44.59l-13.73,72.9,14.5,2.73a7.36,7.36,0,0,0,8.64-6.11Z",
    style: {
      fill: "#f6a860"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.37,107A2.92,2.92,0,0,1,88,103.62l7.72-43.88a2.93,2.93,0,0,1,3.39-2.38h0a2.92,2.92,0,0,1,2.34,3.38L93.8,104.63A2.93,2.93,0,0,1,90.41,107Z",
    style: {
      fill: "#fcdd2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.67,104.61h0a2.93,2.93,0,0,1-2.29-3.45l8.78-43.69a2.93,2.93,0,0,1,5.74,1.16l-8.78,43.68A2.92,2.92,0,0,1,77.67,104.61Z",
    style: {
      fill: "#fcdd2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.34,43.76l1.38-7.3a10.41,10.41,0,0,1,12.15-8.3l18.89,3.56a10.41,10.41,0,0,1,8.3,12.15l-1.38,7.3Z",
    style: {
      fill: "#295b97"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.76,31.72l-9.45-1.78L95,47.47l19.67,3.7,1.38-7.3a10.41,10.41,0,0,0-8.3-12.15Z",
    style: {
      fill: "#163756"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpiceIcon);
export default __webpack_public_path__ + "static/media/spice-icon.532d763329ac377a419e0741159bc0ca.svg";
export { ForwardRef as ReactComponent };